import {useProxy} from "~/composables/useProxy";

export const useRefCodeStore = () => {
  const route = useRoute();
  const items: string[] = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'yclid',
    'ysclid',
    'roistat_visit',
  ];

  const setQueryToCookies = () => {
    const isEmptyQuery = Object.entries(route.query).length === 0;
    if (!isEmptyQuery) {
      Object.entries(route.query).forEach((e: any) => {
        if (items.some((item) => item === e[0])) {
          if (e[0] === 'ysclid' || e[0] === 'yclid') {
            useCookie('yclid', { domain: useProxy().formatProxy(document?.domain) }).value = e[1];
          } else {
            useCookie(e[0], { domain: useProxy().formatProxy(document?.domain) }).value = e[1];
          }
        }
      });
    }
  };

  const setCodeToStorage = () => {
    const isEmptyQuery = Object.entries(route.query).length === 0;
    if (!isEmptyQuery) {
      Object.entries(route.query).forEach((e: any) => {
        if (e[0] === 'c') {
          useCookie('c').value = e[1];
        }
      });
    }
  };

  const checkCodeFromRoute = async () => {
    if ((route.name as string).startsWith('c-id')) {
      useCookie('c').value = route.params.id as string;
    }
  };

  return {
    setQueryToCookies,
    setCodeToStorage,
    checkCodeFromRoute,
  };
};